import React from 'react';

interface Props {
  printNum: number;
  total: number;
}

const RezeptPrintCountBadge: React.FC<Props> = ({ printNum, total }) => {
  return (
    <div className="inline-flex items-center justify-center rounded-md bg-amber-400 text-black text-center leading-tight px-3 py-1  text-sm font-medium min-w-[120px]">
      印刷件数 {printNum}/{total}
    </div>
  );
};

export default RezeptPrintCountBadge;
